import React from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import classnames from 'classnames';

// styles
import useStyles from './styles';

// components
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Break from '../Break/Break';

// pages
import Dashboard from '../../pages/dashboard/Dashboard';
import CallPanel from '../../pages/callpanel/CallPanel';

function Layout(props) {
  var classes = useStyles();
  return (
    <div className={classes.root}>
      <>
        <ToastContainer />
        <Header history={props.history} />
        <Sidebar />
        <div className={classnames(classes.content, { [classes.contentShift]: props.isSidebarOpened, })}>
          {/*<div className={classes.fakeToolbar} />*/}
          {(props.agentState === 'BREAK' || props.agentState === 'READY') && props.breakType !== 'JoinedConference' && !props.agentInConf && <Break />}
          {props.agentState === 'INCALL' ? (
            <Switch>
              <Route path='/app/callpanel' component={CallPanel} />
              <Route path='/app' render={() => <Redirect to='/app/callpanel' />} />
            </Switch>
          ) : (
            <Switch>
              <Route path='/app/dashboard' component={Dashboard} />
              <Route path='/app/callpanel' component={CallPanel} />
            </Switch>
          )}
        </div>
      </>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isSidebarOpened: state.layout.isSidebarOpened,
    agentState: state.agentData.agentState,
    breakType: state.agentData.breakType,
    agentInConf: state.agentData.agentInConf,
  };
};

export default connect(mapStateToProps)(withRouter(Layout));
